type ImageMimeType = 'image/jpeg' | 'image/png' | 'image/webp' | 'image/gif'

export interface ImageMetadata {
  width: number
  height: number
  mimeType: ImageMimeType
}

const EXTENSION_TO_MIME: Record<string, ImageMimeType> = {
  '.webp': 'image/webp',
  '.jpg': 'image/jpeg',
  '.jpeg': 'image/jpeg',
  '.png': 'image/png',
  '.gif': 'image/gif',
}

function inferMimeType(url: string): ImageMimeType {
  const pathname = new URL(url).pathname.toLowerCase()
  for (const [ext, mime] of Object.entries(EXTENSION_TO_MIME)) {
    if (pathname.endsWith(ext)) return mime
  }
  return 'image/webp'
}

export function extractImageMetadata(url: string): Promise<ImageMetadata> {
  return new Promise((resolve) => {
    // crossOrigin을 두지 않는다 — 크기만 읽으므로 CORS가 필요 없고, 파일 서버는 GET에 CORS 헤더를 주지 않아
    // crossOrigin='anonymous'면 늘 실패해 1×1로 저장됐다
    const img = new Image()
    img.addEventListener('load', () => {
      resolve({
        width: img.naturalWidth,
        height: img.naturalHeight,
        mimeType: inferMimeType(url),
      })
    })
    // 불러오지 못하면 1×1로 둔다
    img.addEventListener('error', () => {
      resolve({ width: 1, height: 1, mimeType: inferMimeType(url) })
    })
    img.src = url
  })
}
